import { jwtDecode } from "jwt-decode";
import { DeleteRequest, GetRequest, PostRequest } from "./HttpService";
import { getDecodedUserId } from "./GeneralService";

export const requestLoginCode = async (mobileNumber) => {
  const data = await PostRequest("/Auth/request-code", { mobileNumber });
  return data;
};

export const login = async (mobileNumber, confirmationCode) => {
  const respone = await PostRequest("/Auth/login", {
    mobileNumber,
    confirmationCode,
  });
  return persistLoginSession(respone);
};

export const loginWithPassword = async (mobileNumber, password) => {
  const respone = await PostRequest("/Auth/login-password", {
    mobileNumber,
    password,
  });
  return persistLoginSession(respone);
};

const persistLoginSession = async (respone) => {
  const data = await respone.json();

  localStorage.setItem("token", data.token);
  const decodedToken = jwtDecode(data.token);
  localStorage.setItem("roles", decodedToken.role);
  localStorage.setItem("userId", decodedToken.nameid);
  saveNameToLocalStorage(decodedToken.firstName, decodedToken.lastName);
  return data;
};

export const setPassword = async (password, currentPassword) => {
  const data = await PostRequest("/Auth/set-password", {
    password,
    currentPassword,
  });
  return data;
};

export const CompleteProfile = async (
  firstName,
  lastName,
  nationalcode,
  email,
  password
) => {
  const Id = getDecodedUserId();

  const respone = await PostRequest("/Auth/complete-profile", {
    Id,
    firstName,
    lastName,
    nationalcode,
    email,
    password,
  });
  saveNameToLocalStorage(firstName, lastName);
  return respone;
};

export const EditProfile = async (
  id,
  firstName,
  lastName,
  nationalcode,
  email
) => {
  const data = await PostRequest("/Auth/edit-profile", {
    id,
    firstName,
    lastName,
    nationalcode,
    email,
  });
  saveNameToLocalStorage(firstName, lastName);
  return data;
};

const saveNameToLocalStorage = (firstName, lastName) => {
  localStorage.setItem("userFirstName", firstName);
  localStorage.setItem("userLastName", lastName);
};

export const GetProfileById = async (id) => {
  const data = await GetRequest("/Auth/get-profile", id);

  return data;
};

export const isLoggedIn = () => {
  const token = localStorage.getItem("token");
  if (token === null || token === "") {
    return false;
  }
  const decodedToken = jwtDecode(token);

  const currentTime = Date.now() / 1000;
  if (decodedToken.exp < currentTime) {
    logout();
    return false;
  }

  return !!token;
};

export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("roles");
  localStorage.removeItem("userId");
};

export const CheckRole = (roles) => {
  if (!isLoggedIn()) {
    return false;
  }
  const isPermitted = roles.some((role) =>
    localStorage.getItem("roles")?.split(",").includes(role)
  );

  return isPermitted;
};

export const getUsers = async (userPagingFilter) => {
  const data = await PostRequest("/Auth/get-users", userPagingFilter);

  return data;
};

export const deleteUser = async (id) => {
  const response = await DeleteRequest("/Auth/delete-user", id);
  return response;
};

export const getUserRoles = async (userId) => {
  const data = await GetRequest("/Auth/get-user-roles", userId);
  return data;
};

export const updateUserRoles = async (userId, userRoles) => {
  const respone = await PostRequest(
    "/Auth/update-user-roles",
    userRoles,
    userId
  );
  return respone;
};
